import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_3 = {
  class: "modal",
  style: {"width":"500px","max-height":"500px"}
}
const _hoisted_4 = { class: "modal__header modal__header--success justify--space-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "modal__header--title" }, "Refundable Orders", -1)
const _hoisted_6 = { style: {"overflow":"auto"} }
const _hoisted_7 = { style: {"height":"50px","border-bottom":"1px solid gray","display":"flex"} }
const _hoisted_8 = { style: {"flex":"3","align-self":"center","text-align":"left","margin-left":"20px"} }
const _hoisted_9 = { style: {"flex":"3","align-self":"center","text-align":"left"} }
const _hoisted_10 = { style: {"flex":"1","align-self":"center"} }
const _hoisted_11 = ["id", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("button", {
          type: "button",
          class: "btn btn--secontary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
          style: {"font-weight":"bolder","color":"red","background-color":"white","border-radius":"500px"}
        }, " X ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibleRefunds, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, "Date: " + _toDisplayString(item[0]), 1),
              _createElementVNode("div", _hoisted_9, "Credits: " + _toDisplayString(item[1]), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  id: 'refund-' + index ,
                  class: "btn btn--secondary",
                  style: {"margin-right":"20px"},
                  onClick: ($event: any) => (_ctx.refundOrder(item))
                }, "refund", 8, _hoisted_11)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}